import { lazy } from "react";

const GroupPermission = lazy(() => import("./Group"));

const SlipPermission = lazy(() => import("./Slip"));

const ConfigurationPermission = lazy(() => import("./Configuration"));

const ApprovalConfiguration = lazy(() => import("./Approval"));

const ExportedMaterialConfig = lazy(() => import("./ExportedMaterialConfig"));

export {
  ApprovalConfiguration,
  ConfigurationPermission,
  ExportedMaterialConfig,
  GroupPermission,
  SlipPermission,
};
